<template>
  <router-link router-link :to="{name: 'team.name', params: {id: item.id}}" @click.native="goToTeamProfile" class="card">
    <div class="leftSide">
      <div class="avatarWrapper">
        <img :src="item.logoUrl" alt="not found"/>
      </div>

      <div class="leftSide__wrapper">
        <span class="leftSide__text">{{ item.attributes.name }}</span>
        <span class="leftSide__count">{{ item.countOfPlayers }} участников</span>
      </div>

    </div>

    <div class="rightSide">
      <div class="svgWrapper">
        <country-flag :country="item.attributes.country" size="normal" rounded/>
      </div>
    </div>
  </router-link>
</template>

<script>
import CountryFlag from "vue-country-flag";
import {mapActions} from "vuex";

export default {

  name: "searchTeamCard",
  props: ['item'],
  components: {CountryFlag},
  methods: {
    ...mapActions([
      'SET_PREVENT_FOCUS_INPUT_AND_CLOSE_DROPDOWN'
    ]),
    goToTeamProfile() {
      this.SET_PREVENT_FOCUS_INPUT_AND_CLOSE_DROPDOWN();
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  cursor: pointer;
  padding: 8px 16px;
  background-color: #3A3A3A;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .leftSide {
    display: flex;
    flex-direction: row;
    align-items: center;

    .avatarWrapper {
      width: 40px;
      height: 40px;
      border-radius: 100%;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    &__text {
      color: white;
      font-size: 14px;
      line-height: 17px;
      font-family: 'SF UI Text', serif;
    }

    &__count {
      opacity: .6;
      color: white;
      font-size: 12px;
      line-height: 14.4px;
      font-family: 'SF UI Text', serif;
    }

    &__wrapper {
      margin-left: 8px;
      display: flex;
      flex-direction: column;
    }
  }

  .rightSide {
    .svgWrapper {

    }
  }

  &:hover {
    background-color: lighten(#3A3A3A, 10);
  }
}
</style>
